import { render, staticRenderFns } from "./SelectScene.vue?vue&type=template&id=477d81e6&scoped=true"
import script from "./SelectScene.vue?vue&type=script&lang=js"
export * from "./SelectScene.vue?vue&type=script&lang=js"
import style0 from "./SelectScene.vue?vue&type=style&index=0&id=477d81e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d81e6",
  null
  
)

export default component.exports